var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { PureComponent } from 'react';
import { func, number, string, object } from 'prop-types';
import * as CONST from './const';
import { SIZE } from '../../../../data-parser/div-cards/props/size';
import InViewport from 'searchband-frontend-commons/components/context/in-viewport';
import * as CLS from './cls';

var imageSizeTable = function imageSizeTable(props) {
    var size = props.sizes[props.size];

    return {
        height: size + 'px',
        width: size * props.ratio + 'px'
    };
};

var imageSizeNormal = function imageSizeNormal(props) {
    var size = props.sizes[props.size];

    return {
        width: size + 'px',
        height: size / props.ratio + 'px'
    };
};

var ImageElement = function (_PureComponent) {
    _inherits(ImageElement, _PureComponent);

    function ImageElement() {
        _classCallCheck(this, ImageElement);

        return _possibleConstructorReturn(this, (ImageElement.__proto__ || Object.getPrototypeOf(ImageElement)).apply(this, arguments));
    }

    _createClass(ImageElement, [{
        key: 'renderImage',
        value: function renderImage(inViewport) {
            var props = this.props;
            var crop = props.crop,
                url = props.url;

            var showImage = url && inViewport;
            var placeholder = !showImage;
            var style = _extends({}, props.sizeCalculator(props), {
                backgroundImage: showImage ? 'url(' + url + ')' : ''
            });

            return React.createElement('div', {
                style: style,
                className: CLS.element({ crop: crop, placeholder: placeholder })()
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return React.createElement(
                InViewport.Consumer,
                null,
                function (inViewport) {
                    return _this2.renderImage(inViewport);
                }
            );
        }
    }]);

    return ImageElement;
}(PureComponent);

ImageElement.defaultProps = {
    url: '',
    ratio: 1,
    sizes: {},
    crop: CONST.CROP.top,
    sizeCalculator: imageSizeNormal
};
ImageElement.propTypes = {
    url: string.isRequired,
    ratio: number,
    sizes: object,
    size: string,
    crop: string,
    sizeCalculator: func
};
export default ImageElement;


export var TableImageElement = function TableImageElement(props) {
    return React.createElement(ImageElement, _extends({
        size: SIZE.m,
        sizeCalculator: imageSizeTable
    }, props, {
        sizes: CONST.TABLE_IMAGE_SIZES,
        crop: CONST.CROP.center
    }));
};

export var UniversalImageElement = function UniversalImageElement(props) {
    return React.createElement(ImageElement, _extends({
        size: SIZE.s
    }, props, {
        sizes: CONST.UNIVERSAL_IMAGE_SIZES,
        crop: CONST.CROP.top
    }));
};

export var ButtonImageElement = function ButtonImageElement(props) {
    return React.createElement(ImageElement, _extends({
        size: SIZE.m
    }, props, {
        ratio: 1,
        sizes: CONST.BUTTON_IMAGE_SIZES,
        crop: CONST.CROP.center
    }));
};